import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { FaEnvelope, FaGithub } from "react-icons/fa6";
import "./Footer.css";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="Footer">
            <p className="footer-text">&copy; {year} Gramlich Software Services</p>
            <p className="footer-text footer-contact">
                <a href="mailto:gramlichsoftware@gmail.com" aria-label="Email Gramlich Software Services">
                    <FaEnvelope aria-hidden="true" />
                </a>
                <a href="https://github.com/rileygramlich" target="_blank" rel="noreferrer" aria-label="GitHub profile">
                    <FaGithub aria-hidden="true" />
                </a>
                <a href="https://www.linkedin.com/in/rileygramlich/" target="_blank" rel="noreferrer" aria-label="LinkedIn profile">
                    <FaLinkedin aria-hidden="true" />
                </a>
            </p>
        </footer>
    );
}
